export function versionErrorHintMessage(message, method) {
    return `${message}\nHint: It might not be working because maybe you're not up to date with the Meilisearch version that ${method} call requires.`;
}
//# sourceMappingURL=version-hint-message.js.map